import { debug, observer, pr, React, RouteComponentProps } from "aaa";
import { ui } from "components/util/uiHelpers";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { SurveyStore } from "./SurveyStore";

type IProps = RouteComponentProps<{}> & {
    store: SurveyStore;
};

@observer
export class SurveySigning extends React.Component<IProps, {}> {
    render() {
        const title = this.props.store.formDefinition?.body.find(element => element.component === "headline")?.title;

        return (
            <SigningComponent
                signingInfo={this.props.store.signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                                <pr.SigningLabel>{ui.__("survey.signing.action.label", { title })}</pr.SigningLabel>
                            </pr.SigningLabelSet>
                        </pr.SigningLabelContainer>
                    </div>
                }
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}
                onRetry={async () => await this.props.store.submitSurvey()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/survey/SurveySigning.tsx